export enum Feature {
  ExhibitHall = 'ExhibitHall',
  ProfileSetup = 'ProfileSetup',
  Analytics = 'Analytics',
  NotificationManager = 'NotificationManager',
  AdvancedSettings = 'AdvancedSettings',
  EmailDomainWhitelist = 'EmailDomainWhitelist',
}
